module.exports = __webpack_public_path__ + "static/media/logo-border.6a834e8c.png";